import { Component, Input } from '@angular/core'

import { BillingService } from '@shared/services/billing.service'

import { BillingQuantitiesFields, BillingPricingFields } from '@shared/models/billing.model'
import { PlatformSettingsService } from '@app/core/services/platfrom-settings.service'

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[billingTableRowExpanded]',
  templateUrl: './billing-table-row-expanded.component.html',
  styleUrls: ['./billing-table-row-expanded.component.scss'],
  standalone: false,
})
export class BillingTableRowExpandedComponent {
  @Input() name: string
  @Input() notEditable = false

  get quantity(): number {
    return <number>this.billingService.billingQuantities[<string>BillingQuantitiesFields[this.name]]
  }

  get price(): number {
    return <number>this.billingService.billingPricing[<string>BillingPricingFields[this.name]] || 0
  }
  set price(value: number) {
    this.billingService.billingPricing[<string>BillingPricingFields[this.name]] = value
  }

  get clientCurrencySymbol(): string {
    return this.platformSettingsService.getClientCurrency()?.symbol
  }

  constructor(
    private readonly billingService: BillingService,
    private readonly platformSettingsService: PlatformSettingsService,
  ) {}
}
